// src/pages/Onboarding.jsx
import React from "react";
import { Navigate } from "react-router-dom";
import OnboardingNominator from "./OnboardingNominator";
import OnboardingEmpSupplierAdmin from "./OnboardingEmpSupplierAdmin";
import OnboardingFteNominator from "./OnboardingFteNominator";

/**
 * Role-based onboarding router.
 *
 * - Nominator + DTV OPS Admin -> OnboardingNominator
 * - Employee Supplier*        -> OnboardingEmpSupplierAdmin
 * - FTE Nominator / tb_isFte  -> OnboardingFteNominator
 */
export default function Onboarding() {
    const rawRole = (sessionStorage.getItem("tb_role") || "").trim();
    const isFteFlag = sessionStorage.getItem("tb_isFte") === "1";

    const roleLc = rawRole.toLowerCase();

    // console.log("Onboarding -> rawRole:", rawRole, "isFteFlag:", isFteFlag);

    /**
     * If there is NO role info at all, treat it as invalid/expired session.
     * Force user back through login/root.
     */
    if (!rawRole && !isFteFlag) {
        try {
            sessionStorage.clear();
        } catch {
            // ignore storage issues
        }
        // Adjust this path if your login route is different (e.g. "/login")
        return <Navigate to="/" replace />;
    }

    // ===== Flexible role detection =====
    //const isExactFteNominator = /\bfte\s*nominator\b/i.test(rawRole);

    const isExactFteNominator = /^fte\s+nominator$/i.test(rawRole?.trim() || "");

    // Anything that looks like "employee supplier ..." is treated as Supplier Admin
    const isEmployeeSupplierAdmin =
        /\bemployee\s*supplier\b/i.test(rawRole) ||
        roleLc.includes("supplier admin") || roleLc.includes("sponsor");

    // Any role containing "nominator" (other than the employee supplier case above) is a Nominator
    const isNominator =
        /\bnominator\b/i.test(rawRole) && !isEmployeeSupplierAdmin;

    const isOpsAdmin =
        /\bdtv\s*ops\s*admin\b/i.test(rawRole) ||
        roleLc.includes("ops admin");

    // ===== Routing decisions =====

    // FTE Nominator view: explicit role OR FTE flag with no conflicting supplier/admin role
    if (isExactFteNominator || (!rawRole && isFteFlag)) {
        return <OnboardingFteNominator />;
    }

    // Employee Supplier Admin or DTV OPS ADMIN view (covers "Employee Supplier Admin", "Employee Supplier Nominator", etc.)
    if (isEmployeeSupplierAdmin || isOpsAdmin) {
        return <OnboardingEmpSupplierAdmin />;
    }

    // Nominator
    if (isNominator) {
        return <OnboardingNominator />;
    }

    // Fallback: just use nominator page for anything unknown
    return <OnboardingNominator />;
}
